// Import simulated data
import { 
    SIMULATED_DATA, 
    TOTAL_SIMULATED_USERS, 
    TOTAL_SIMULATED_SOL,
    TOTAL_SIMULATED_JINU,
    getSimulatedData,
    useSimulatedData 
} from './simulatedData';

// Function to check if a task is completed
export const isTaskCompleted = (platform, task) => {
    // In a real implementation, this would check against the user's completed tasks
    // For now, return false for all tasks
    return false; // For now, return false as we haven't implemented social tasks yet
};

// Export simulated data
export { 
    SIMULATED_DATA, 
    TOTAL_SIMULATED_USERS, 
    TOTAL_SIMULATED_SOL,
    TOTAL_SIMULATED_JINU,
    getSimulatedData,
    useSimulatedData 
};

// Social Tasks
export const TASKS = {
    TWITTER_FOLLOW: 'follow',
    TWITTER_BIO: 'bio',
    TWITTER_RETWEET: 'retweet',
    DISCORD_JOIN: 'join',
    DISCORD_VERIFY: 'verify',
    DISCORD_REACT: 'react'
};

// Auction Constants
export const AUCTION_DAYS = 50; // Number of actual auction days
export const TOTAL_DAYS = 50; // Total auction days
export const DEX_LISTING_DAY = 51; // DEX listing day (after auction ends)
export const SOL_PRICE_USD = 200; // 1 SOL = $200 USD
export const TOTAL_AUCTION_TOKENS = 37500000; // 37.5 million JINU tokens
export const CIRCULATING_SUPPLY = 37500000; // Total circulating supply: 37.5M JINU
export const START_PRICE = 0.00001; // Initial price $0.00001
export const AUCTION_START_DATE = '2025-03-25T00:00:00Z';  // Updated to start on March 25th, 2025
export const BONUS_DAYS = [1, 2, 3, 4, 5, 6, 7]; // Days with bonus multipliers

// Daily allocation
export const DAILY_ALLOCATION = 750000; // Fixed 750,000 JINU per day

// Get daily allocation with ±35% random variation
export const getDailyAllocation = (day) => {
    const seededRandom = (seed) => {
        const x = Math.sin(seed) * 10000;
        return x - Math.floor(x);
    };
    
    // Random variation between -35% and +35%
    const variation = -0.35 + (seededRandom(day * 7) * 0.7); // 0.7 is the range (-35% to +35%)
    const allocation = Math.floor(DAILY_ALLOCATION * (1 + variation));
    
    // Removed console.log for production
    
    return allocation;
};

// Calculate token allocation per SOL
export const calculateTokensPerSol = (day, totalSolForDay) => {
    if (totalSolForDay <= 0) return 0;
    const allocation = getDailyAllocation(day);
    return allocation / totalSolForDay; // Tokens per SOL for this day
};

// Affiliate Constants
export const AFFILIATE_COMMISSION_RATE = 0.10; // 10% commission rate
export const AFFILIATE_POOL_ALLOCATION = 10000000; // 10M JINU for affiliate pool

// Export a dummy getBonusMultiplier that always returns 1 (no bonus)
export const getBonusMultiplier = () => 1;
